import {
  ElementType,
  HTMLAttributes,
  HTMLAttributeAnchorTarget,
  ReactNode,
  forwardRef,
} from 'react';

// This is a generic component for dynamic tags
// All uncommon attribute has to be specified in the Props to pass TS type checks
// For example, "href" only exists in anchor tag

type Ref = HTMLElement | null;

interface Props extends HTMLAttributes<HTMLElement> {
  as?: ElementType;
  children: ReactNode;
  href?: string;
  target?: HTMLAttributeAnchorTarget;
  disabled?: boolean;
  type?: 'submit' | 'reset' | 'button';
  'aria-haspopup'?:
    | boolean
    | 'false'
    | 'true'
    | 'menu'
    | 'listbox'
    | 'tree'
    | 'grid'
    | 'dialog';
}

export const Tag = forwardRef<Ref, Props>(
  ({ as: Component = 'div', children, ...otherProps }, ref) => {
    return (
      <Component ref={ref} {...otherProps}>
        {children}
      </Component>
    );
  },
);

Tag.displayName = 'Tag';
